import { defineMessages } from 'react-intl';

const messages = defineMessages({
  studentHeading: {
    id: 'hubs.profiles.student-profiles-heading',
    defaultMessage: 'Get to know the student body',
  },
  learnMoreAboutStudents: {
    id: 'hubs.profiles.learn-more-about-students',
    defaultMessage: 'Learn more about {college} from students attending.',
  },
  facultyHeading: {
    id: 'hubs.profiles.faculty-profiles-heading',
    defaultMessage: 'Get to know the faculty',
  },
  learnMoreAboutFaculty: {
    id: 'hubs.profiles.learn-more-about-faculty',
    defaultMessage: 'Learn more about {college} from the faculty.',
  },
  programHeading: {
    id: 'hubs.profiles.program-profiles-heading',
    defaultMessage: 'Get to know the programs',
  },
  learnMoreAboutPrograms: {
    id: 'hubs.profiles.learn-more-about-programs',
    defaultMessage: 'Learn more about {college} from the programs.',
  },
  alumniHeading: {
    id: 'hubs.profiles.alumni-profiles-heading',
    defaultMessage: 'Get to know the alumni',
  },
  learnMoreAboutAlumni: {
    id: 'hubs.profiles.learn-more-about-alumni',
    defaultMessage: 'Learn more about {college} from the alumni.',
  },

  readMoreBtn: {
    id: 'hubs.profiles.read-more-btn',
    defaultMessage: 'Read More',
  },
  favCampusActivities: {
    id: 'hubs.profiles.fav-campus-activities',
    defaultMessage: 'Favorite campus activities:',
  },
  favCampusHangout: {
    id: 'hubs.profiles.fav-campus-hangout',
    defaultMessage: 'Favorite campus hangout:',
  },
  favPlaceToEat: {
    id: 'hubs.profiles.fav-place-to-eat',
    defaultMessage: 'Where is the best place to eat on campus?',
  },
  travel: {
    id: 'hubs.profiles.travel-arrangments',
    defaultMessage: 'Car, bus, or bike – how do most students travel:',
  },
  alumniMore: {
    id: 'hubs.profiles.more-about-alumni',
    defaultMessage: 'More about this alum:',
  },
  facultyMore: {
    id: 'hubs.profiles.more-about-faculty',
    defaultMessage: 'More about this faculty:',
  },
  programMore: {
    id: 'hubs.profiles.more-about-program',
    defaultMessage: 'More about this program:',
  },
});

export default messages;
